/**
 * Decision coin PDP: gallery (Side A / B ↔ first two media), thumbnails, char counters, qty UI.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.coinPdpInit === 'true') return;
    root.dataset.coinPdpInit = 'true';

    const mainImg = root.querySelector('[data-coin-main-img]');
    const pillA = root.querySelector('[data-coin-pill="a"]');
    const pillB = root.querySelector('[data-coin-pill="b"]');
    const thumbs = root.querySelectorAll('[data-coin-thumb]');
    const mediaJson = root.querySelector('[data-coin-media-json]');
    const qtyDisplay = root.querySelector('[data-coin-qty-display]');
    const qtyInput = root.querySelector('input[name="quantity"]');
    const nameA = root.querySelector('#coin-name-a');
    const nameB = root.querySelector('#coin-name-b');
    const ccA = root.querySelector('[data-char-count="a"]');
    const ccB = root.querySelector('[data-char-count="b"]');
    const notes = root.querySelector('#coin-order-notes');
    const notesCounter = root.querySelector('[data-notes-counter]');
    const notesHidden = root.querySelector('[data-order-notes-property]');
    const wishlistBtn = root.querySelector('[data-coin-wishlist-btn]');
    const wishlistIcon = root.querySelector('[data-coin-wishlist-icon]');
    const wishlistLabel = root.querySelector('[data-coin-wishlist-label]');
    const defaultWishlistLabel = (wishlistLabel?.textContent || 'Save for later').trim();
    const wishlistStorageKey = 'etchfyWishlistProducts';
    const productId = String(root.dataset.coinProductId || '');
    const productHandle = root.dataset.coinProductHandle || '';
    const productTitle = root.dataset.coinProductTitle || '';
    const productUrl = root.dataset.coinProductUrl || '';
    const productImage = root.dataset.coinProductImage || '';
    const maxName = parseInt(root.dataset.maxName || '12', 10);
    const maxNotes = parseInt(root.dataset.maxNotes || '250', 10);

    let media = [];
    try {
      media = JSON.parse(mediaJson?.textContent || '[]');
    } catch (e) {
      media = [];
    }

    let activeIndex = 0;

    function setMainByIndex(index) {
      if (!mainImg || !media.length) return;
      const i = Math.max(0, Math.min(index, media.length - 1));
      activeIndex = i;
      const item = media[i];
      if (item?.preview) {
        mainImg.src = item.preview;
        mainImg.alt = item.alt || '';
      }
      thumbs.forEach((t) => {
        t.classList.toggle('active', parseInt(t.dataset.coinThumb, 10) === i);
      });
      if (pillA && pillB) {
        pillA.classList.toggle('active', i === 0);
        pillA.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        pillB.classList.toggle('active', i === 1);
        pillB.setAttribute('aria-pressed', i === 1 ? 'true' : 'false');
      }
    }

    function showSide(side) {
      if (side === 'b' && media.length > 1) {
        setMainByIndex(1);
      } else {
        setMainByIndex(0);
      }
    }

    pillA?.addEventListener('click', () => showSide('a'));
    pillB?.addEventListener('click', () => showSide('b'));

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.dataset.coinThumb, 10);
        if (!Number.isNaN(idx)) setMainByIndex(idx);
      });
    });

    setMainByIndex(0);

    function updateNameCount(side) {
      const input = side === 'a' ? nameA : nameB;
      const counter = side === 'a' ? ccA : ccB;
      if (!input || !counter) return;
      const n = input.value.length;
      counter.textContent = `${n} / ${maxName}`;
      counter.classList.toggle('warn', n >= maxName);
    }

    nameA?.addEventListener('input', () => updateNameCount('a'));
    nameB?.addEventListener('input', () => updateNameCount('b'));
    updateNameCount('a');
    updateNameCount('b');

    function updateNotesCount() {
      if (!notes || !notesCounter) return;
      const n = notes.value.length;
      notesCounter.textContent = `${n} / ${maxNotes}`;
      notesCounter.classList.toggle('warn', n >= maxNotes);
      if (notesHidden) {
        const v = notes.value.trim();
        if (v) {
          notesHidden.value = v;
          notesHidden.removeAttribute('disabled');
        } else {
          notesHidden.value = '';
          notesHidden.setAttribute('disabled', 'disabled');
        }
      }
    }

    notes?.addEventListener('input', updateNotesCount);
    updateNotesCount();

    const qtyMin = Math.max(1, parseInt(qtyInput?.getAttribute('min') || '1', 10));

    function syncQtyDisplay() {
      if (!qtyInput || !qtyDisplay) return;
      let q = parseInt(qtyInput.value, 10);
      if (Number.isNaN(q) || q < qtyMin) q = qtyMin;
      const maxAttr = qtyInput.getAttribute('max');
      if (maxAttr) {
        const qMax = parseInt(maxAttr, 10);
        if (!Number.isNaN(qMax)) q = Math.min(q, qMax);
      }
      qtyInput.value = String(q);
      qtyDisplay.textContent = String(q);
    }

    root.querySelector('[data-coin-qty-minus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      let q = parseInt(qtyInput.value, 10) || qtyMin;
      qtyInput.value = String(Math.max(qtyMin, q - 1));
      syncQtyDisplay();
    });

    root.querySelector('[data-coin-qty-plus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      let q = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = String(q + 1);
      syncQtyDisplay();
    });

    syncQtyDisplay();

    function getWishlistItems() {
      try {
        const parsed = JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }

    function setWishlistItems(items) {
      localStorage.setItem(wishlistStorageKey, JSON.stringify(items));
    }

    function isWishlisted(items) {
      return items.some((item) => String(item.id) === productId);
    }

    function renderWishlistState(saved) {
      if (!wishlistBtn) return;
      wishlistBtn.classList.toggle('is-active', saved);
      wishlistBtn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      if (wishlistIcon) wishlistIcon.textContent = saved ? '♥' : '♡';
      if (wishlistLabel) wishlistLabel.textContent = saved ? 'Saved' : defaultWishlistLabel;
    }

    wishlistBtn?.addEventListener('click', () => {
      if (!productId) return;
      const items = getWishlistItems();
      const saved = isWishlisted(items);

      if (saved) {
        setWishlistItems(items.filter((item) => String(item.id) !== productId));
        renderWishlistState(false);
      } else {
        items.push({
          id: productId,
          handle: productHandle,
          title: productTitle,
          url: productUrl,
          image: productImage
        });
        setWishlistItems(items);
        renderWishlistState(true);
      }
    });

    renderWishlistState(isWishlisted(getWishlistItems()));

    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    form?.addEventListener(
      'submit',
      (e) => {
        let ok = true;
        if (nameA && !nameA.value.trim()) {
          nameA.classList.add('error');
          ok = false;
        } else nameA?.classList.remove('error');
        if (nameB && !nameB.value.trim()) {
          nameB.classList.add('error');
          ok = false;
        } else nameB?.classList.remove('error');
        if (!ok) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  document.querySelectorAll('[data-decision-coin-pdp]').forEach(init);
})();
